import L from 'leaflet';
import { HotlineCanvas } from '../canvas/HotlineCanvas';
import Converter from '../converter';
import clipSegment from './clipSegment';
export default class HotPolyline extends L.Polyline {
    constructor(renderer, coords, getLat, getLng, getVal) {
        const canvas = new HotlineCanvas(renderer);
        const latlngs = Converter.toLatLngs(coords, getLat, getLng, getVal);
        super(latlngs, { renderer: canvas, interactive: false });
        this.projectMap = renderer.projectLatLngs;
        this._canvas = canvas;
    }
    remove() {
        super.remove();
        this._canvas.remove();
        return this;
    }
    setLatLngs(latlngs) {
        super.setLatLngs(latlngs);
        this._canvas._update();
        return this;
    }
    setOptions(options) {
        this._canvas._renderer.setOptions(options);
        this._canvas._update();
        this.redraw();
    }
    _projectLatlngs(latlngs, result, projectedBounds) {
        if (Array.isArray(latlngs[0]))
            latlngs.forEach((_latlngs, p) => this.projectMap(this._map, _latlngs, result, projectedBounds, p));
        else
            this.projectMap(this._map, latlngs, result, projectedBounds, 0);
        if (this._canvas._renderer === undefined)
            return;
        this._canvas._renderer.projectedData = [...result];
        this._canvas._renderer.onProjected();
    }
    /**
     * From: https://github.com/iosphere/Leaflet.hotline/blob/49e6f45dc98e1432e6a8f849ba4c2b9dd0356c8b/src/leaflet.hotline.js#L414
     */
    _clipPoints() {
        if (this._canvas._renderer === undefined)
            return;
        if (this.options.noClip) {
            ;
            this._parts = this._rings;
            return;
        }
        ;
        this._parts = [];
        const parts = this._parts;
        const bounds = this._pxBounds;
        for (let i = 0, k = 0, len = this._rings.length; i < len; i++) {
            const points = this._rings[i];
            for (let j = 0, len2 = points.length; j < len2 - 1; j++) {
                const segment = clipSegment(this._canvas._renderer, points[j], points[j + 1], bounds, j, true);
                if (segment === undefined) {
                    continue;
                }
                parts[k] = parts[k] || [];
                parts[k].push(segment[0]);
                // if segment goes out of screen, or it's the last one, it's the end of the line part
                if (segment[1] !== points[j + 1] || j === len2 - 2) {
                    parts[k].push(segment[1]);
                    k++;
                }
            }
        }
    }
    _clickTolerance() {
        return (this.options.weight / 2 +
            this.options.outlineWidth +
            (L.Browser.touch ? 10 : 0));
    }
}
